import { css } from '@emotion/react';
import { ImageFit } from '../types';
import { cssStringToBuilderReturnType } from './commonUtils';
const getContentCss = (infoPosition, contentItemsAlignment) => {
  const isFlexDirRow = ['LEFT', 'RIGHT', 'ON_IMAGE'].includes(infoPosition);
  const flexDirectionMap = {
    ABOVE: 'column-reverse',
    BELOW: 'column',
    LEFT: 'row-reverse',
    RIGHT: 'row',
    ON_IMAGE: 'row'
  };
  return {
    '.content': {
      justifyContent: isFlexDirRow ? 'center' : contentItemsAlignment,
      alignItems: isFlexDirRow ? contentItemsAlignment : 'center',
      flexDirection: flexDirectionMap[infoPosition] || 'column'
    },
    '.info': {
      // display: enableTitle ? 'block' : 'none',
    },
    ...(infoPosition === 'ON_IMAGE' ? {
      '.content .info': {
        position: 'absolute',
        textAlign: 'center',
        width: '100%',
        color: '#000000',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }
    } : {})
  };
};
const getMediaCss = (imageFit // fix type
) => {
  return {
    '.media': {
      height: imageFit === ImageFit.crop ? '100%' : 'auto'
    },
    '.image': {
      objectFit: imageFit === ImageFit.crop ? 'cover' : 'contain'
    }
  };
};
const getItemCss = () => {
  return {};
};
export const buildItemStyles = function (styles) {
  if (styles === void 0) {
    styles = {};
  }
  const {
    infoPosition = 'ABOVE',
    // enableTitle = true,
    imageFit = ImageFit.crop,
    contentItemsAlignment = 'flex-start'
  } = {
    ...styles
  };
  const itemRule = css(getItemCss()).styles;
  const contentRule = css(
  // getContentCss(infoPosition, enableTitle, contentItemsAlignment),
  getContentCss(infoPosition, contentItemsAlignment)).styles;
  const mediaRule = css(getMediaCss(imageFit)).styles;
  return cssStringToBuilderReturnType(itemRule + contentRule + mediaRule);
};
//# sourceMappingURL=itemBuilder.js.map